import CashbackEarnedScreenV2 from 'features/rewards/Cashback/CashbackEarnedScreenV2';
import React from 'react';

export default function Page() {
  return <CashbackEarnedScreenV2 />;
}
